import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path
      d="M4 16h6m12 0h6M16 4v6m0 12v6m4.5-7.5l4 4m-17-17l4 4m-.293 9l-4 4m17-17l-4 4"
      fill="none"
    />
  </Icon>
);
